import { useData } from '../../../../../hooks/useData';
import FranchiseReportEmailsConfiguration from './FranchiseReportEmailsConfiguration';
import RegionsConfigurationNew from './RegionsConfigurationNew';
import UpdateFranchiseDayPartsConfiguration from './UpdateFranchiseDayPartsConfiguration';


const FranchiseConfiguration: React.FC = () => {
    const {
        franchiseConfiguration,
    } = useData();

    if (!franchiseConfiguration) return <div>Loading...</div>;

    return (
        <div>
            <FranchiseReportEmailsConfiguration />
            <RegionsConfigurationNew />
            <UpdateFranchiseDayPartsConfiguration />
        </div>
    );
};

export default FranchiseConfiguration;
